module.exports = __webpack_public_path__ + "img/greece.09dbde7f.svg";